import { render, staticRenderFns } from "./ImagemCarouselDialog.vue?vue&type=template&id=9f7b6ade&scoped=true&"
import script from "./ImagemCarouselDialog.vue?vue&type=script&lang=js&"
export * from "./ImagemCarouselDialog.vue?vue&type=script&lang=js&"
import style0 from "./ImagemCarouselDialog.vue?vue&type=style&index=0&id=9f7b6ade&prod&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f7b6ade",
  null
  
)

export default component.exports